import { Fragment, useState, useRef, useEffect } from "react";
import "./package_offering_component.scss";
import { isEmpty } from "../../../../../../custom_utilities/custom_useful_functions";
import images from "../../../../../../utilities/images/images";
import { useLocation } from "react-router-dom";
import { navigateToPackagePage } from "../../../../../../custom_utilities/dashboardBannerNavigation";
import { trackWebEngageBuyNow } from "../../../../../../custom_utilities/webengage/webengageService";
import SortingCard from "./Card/SortingCard";
import VarientCard from "./Card/varients-card/VarientCard";

const PackageOfferingComponent = (props) => {
  let {
    allPackagesCollection,
    learnMoreBtn,
    sortValue,
    setSortValue,
    startLoading,
    finishLoading,
    history,
    setStoreCurrentPackageDetails,
  } = props;

  const location = useLocation();
  const defaultTab = location?.state?.setActiveTab ?? 1;
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [openSorting, setOpenSorting] = useState(false);
  const sortingRef = useRef(null);
  const [openVarientModal, setOpenVarientModal] = useState(false);
  const [currentPackage, setCurrentPackage] = useState({});

  useEffect(() => {
    const moduleId = Number(location?.state?.targetModuleId);
  
    if (moduleId && allPackagesCollection?.package?.length) {
  
      const matched = allPackagesCollection.package.find(
        (pkg) => Number(pkg.package_id) === moduleId
      );
    
      if (matched) {
        navigateToPackagePage(history, matched.package_id);
      } else {
        console.error("❌ No matching package in store");
      }
    }
  }, [allPackagesCollection]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sortingRef.current && !sortingRef.current.contains(event.target)) {
        setOpenSorting(false);
      }
    };

    if (openSorting) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openSorting]);

  const openSortingOptions = () => {
    setOpenSorting((prev) => !prev);
  };

  const handleOnClickVariantPkg = (element) => {
    setStoreCurrentPackageDetails(element);
    setCurrentPackage(element);
    setOpenVarientModal(true);
  };

  const handleCardBuyNow = (element) => {
    // Variant packages open a modal — fire buy_now only on final variant Buy Now.
    if (element.type === "variant") {
      handleOnClickVariantPkg(element);
      return;
    }
    trackWebEngageBuyNow(element, { card_section: "store" });
    learnMoreBtn(element);
  };

  return (
    <Fragment>
      <div className="package_offering_component_wrapper">
        <div className="store_banner">
          <img
            style={{ width: "1276px", height: "399px", borderRadius: "8px" }}
            src={allPackagesCollection?.banner?.banner_image}
            alt="store banner"
          />
        </div>
        <div className="store-header-sorting-wrapper">
          <div className="package_filter_div d-flex">
            {!isEmpty(allPackagesCollection?.category_list) &&
              allPackagesCollection?.category_list.map((element, key) => {
                return (
                  <div key={key}>
                    <button
                      onClick={() => {
                        setActiveTab(element.id);
                      }}
                      className={activeTab === element.id ? "active" : ""}
                    >
                      {element.category_name}
                    </button>
                  </div>
                );
              })}
          </div>

          <div className="store-sorting" onClick={openSortingOptions}>
            Sort by
            <img src={images.storeSort} alt="sort-icon" />
          </div>

          {openSorting && (
            <div ref={sortingRef}>
              <SortingCard
                sort_by_options={allPackagesCollection?.sort_by_options}
                sortValue={sortValue}
                setSortValue={setSortValue}
                onClose={() => setOpenSorting(false)}
              />
            </div>
          )}
        </div>
        <div className="package_offering_component_inner_wrapper">
          {!isEmpty(allPackagesCollection?.package)
            ? allPackagesCollection?.package
                .filter((packageItem) =>
                  packageItem.category_id.some(
                    (category) => category.category_id === activeTab
                  )
                )
                .map((element, index) => {
                  return (
                    <div className="package_outer" key={index}>
                      <div className="package_name_banner">
                        <img src={element.icon} alt="package banner" />
                        <p
                          style={{
                            backgroundColor: element.tag_background,
                            color: element.tag_textcolor,
                          }}
                        >
                          {element.thumbnail_tag}
                        </p>
                      </div>
                      <p className="package_description">
                        {element.description}
                      </p>
                      <div className="package_flex d-flex justify-content-between">
                        <div className="duration_div">
                          <div className="d-flex mb-2">
                            <img
                              src={images.user_activity_calendar}
                              alt="calendar"
                            />
                            <p>{element.duration}</p>
                          </div>

                          {element.course_benefits_count !== 0 && (
                            <div className="d-flex mb-1">
                              <img src={images.new_store_tick} alt="tick" />
                              <p>{element.course_benefits_count}+ benefits</p>
                            </div>
                          )}

                          {activeTab === 5 &&
                            element?.filo_session_mins_allowed && (
                              <div className="d-flex">
                                <img src={images.storetimer} alt="timer" />
                                <p>{element?.filo_session_mins_allowed} mins</p>
                              </div>
                            )}
                        </div>

                        {parseFloat(element.amount) -
                          parseFloat(element.discount) !==
                          parseFloat(element.amount) && (
                          <div className="discount_div d-flex align-items-center">
                            <img src={images.store_offer} alt="offer" />
                            <p>
                              <span>
                                {Math.round(
                                  (parseFloat(element.discount) /
                                    parseFloat(element.amount)) *
                                    100
                                )}
                                %
                              </span>{" "}
                              Off
                            </p>
                          </div>
                        )}

                        <div className="price_div">
                          <p className="final_amount">
                            ₹
                            {parseFloat(element.amount) -
                              parseFloat(element.discount)}
                          </p>
                          {parseFloat(element.amount) -
                            parseFloat(element.discount) !==
                            parseFloat(element.amount) && (
                            <p className="initial_amount">
                              ₹
                              <span className="text-decoration-line-through">
                                {parseFloat(element.amount)}
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="package_button_div">
                        <button
                          className="details"
                          style={{ width: element.is_subscribe && "100%" }}
                          onClick={() => learnMoreBtn(element)}
                        >
                          View Details
                        </button>

                        {!element.is_subscribe && (
                          <button
                            onClick={() => handleCardBuyNow(element)}
                            className="buy"
                          >
                            Buy Now
                            {element.type === "variant" && (
                              <img
                                className="downarrowImg"
                                src={images.downArrow}
                                alt=""
                              />
                            )}
                          </button>
                        )}
                      </div>
                      <div className="pkg-bottom-bar d-flex justify-content-between">
                        {element?.is_recommended ? (
                          <div className="pkg-recommended d-flex align-items-center">
                            <img
                              src={images.recommended}
                              alt="recommended-icon"
                            />
                            <span>Recommended</span>
                          </div>
                        ) : null}
                        {element?.bottom_note && (
                          <div className="pkg-bottom-note">
                            {element.bottom_note}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
            : "No Courses available"}
        </div>
      </div>

      {openVarientModal && (
        <VarientCard
          show={true}
          onHide={() => setOpenVarientModal(false)}
          packageId={currentPackage?.package_id}
          startLoading={startLoading}
          finishLoading={finishLoading}
          history={history}
          learnMoreBtn={learnMoreBtn}
        />
      )}
    </Fragment>
  );
};

export default PackageOfferingComponent;
